module.exports = __webpack_public_path__ + "img/10blue.8d47e5e1.png";